import { NgModule } from '@angular/core'; 
import { CommonModule } from '@angular/common';
import { FacebookAuthComponent } from './facebook-auth/facebook-auth.component';
import { FacebookAuthService } from './facebook-auth/facebook-auth.service';
import { SocialsService } from './socials.service';
import { GoogleAuthComponent } from './google-auth/google-auth.component';
import { GoogleAuthRoutingModule } from './google-auth/google-auth-rounting.module';
import { GoogleAuthService } from './google-auth/google-auth.service'; 
import { GoogleAuthModule } from './google-auth/google-auth.module';
import { GoogleAuthPopupComponent } from './google-auth/google-auth-popup/google-auth-popup.component';

@NgModule({
  declarations: [FacebookAuthComponent,GoogleAuthComponent,GoogleAuthPopupComponent],
  imports: [CommonModule,GoogleAuthModule],
  exports: [FacebookAuthComponent,GoogleAuthComponent],
  providers: [GoogleAuthService,FacebookAuthService, SocialsService]
})
export class SocialModule { }
